import React from 'react'
import { useForm } from 'react-hook-form'
import { Card } from 'src/Common/ui/card'
import Textarea from 'src/Common/ui/textArea'
import { CHIP_VERY_HIGH, CHIP_VERY_LOW } from 'src/Entities/IssueTypes'
import { cn } from 'src/lib/utils'

export default function Assessors ({ data, type = 'RISK' }) {
    const { register, control, formState: { errors } } = useForm({})
    const chipColorStyle = riskScoreValue => {
        let textColor = 'hsl(var(--foreground))'
        if (riskScoreValue === 'Controlled' || riskScoreValue === CHIP_VERY_LOW) {
            textColor = 'hsl(var(--Controlled))'
        } else if (riskScoreValue === 'Low') {
            textColor = 'hsl(var(--Low))'
        } else if (riskScoreValue === 'Medium') {
            textColor = 'hsl(var(--Medium))'
        } else if (riskScoreValue === 'High') {
            textColor = 'hsl(var(--High))'
        } else if (riskScoreValue === 'Extreme' || riskScoreValue === CHIP_VERY_HIGH) {
            textColor = 'hsl(var(--Extreme))'
        }
        return textColor
    }

    return (
        <div className="flex flex row justify-between w-full">
            <Card className='w-[60%] p-6'>
                <p className='risk-content-title' style={{ margin: 0 }}> {type === 'RISK' ? 'Assessors Risk Scoring' : 'Assessors Issue Scoring' }</p>
                <div className='flex justify-between mt-5'>
                    <div className='flex gap-1 items-center'>
                        <div className='text-xl text-primary'>Priority :</div>
                        <div className='text-xl text-muted' style={{ textDecoration: 'underline' }}>{data?.impact}</div>
                    </div>
                    <div className='flex gap-1 items-center'>
                        <div className='text-xl text-primary'>Severity :</div>
                        <div className='text-xl text-muted' style={{ textDecoration: 'underline' }}>{data?.probability}</div>
                    </div>
                    <div className='flex gap-1 items-center'>
                        <div className='text-xl text-primary'>{type === 'RISK' ? 'Risk Level' : 'Issue Level' }:</div>
                        {data?.riskScore ? <span className={'risk-level'} style={{ backgroundColor: chipColorStyle(data?.riskScore) }}>{data?.riskScore || '-'}</span> : '-'}
                        {/* <div
                            style={{
                                minWidth: '24%',
                                padding: '3px 20px',
                                backgroundColor: 'hsl(var(--primary))',
                                color: 'hsl(var(--card))',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s, border-color 0.3s, color 0.3s',
                                borderRadius: '999px'
                            }}
                            className="risktable-chip"
                        ><div className="flex items-center gap-1 justify-around">High</div></div> */}
                    </div>
                </div>
            </Card>
            <div className="flex flex-col w-[40%] ml-3">
                <div className="relative" style={{ marginBottom: '2%' }}>
                    <Textarea disabled={true} className={cn('ml-[0px]')} label={`Impact of ${type === 'RISK' ? 'Risk' : 'Issue'}`} rules={{
                        validate: (value) => {
                            if (!value) return 'This field is required'
                            if (value?.length > 251) return 'Character count should not exceed 250'
                            return true
                        }
                    }} register={register} value={data?.impactOfRisk} type="text" placeholder="Enter Impact of Risk" name="impactOfRisk" errors={errors} control={control} required maxLength={250}/>
                    <div className={cn('absolute bottom-[25px] right-[10px] text-muted text-[10px]', data?.impactOfRisk?.length > 250 ? '!text-danger' : 'text-muted')}>{data?.impactOfRisk?.length || 0}/250</div>
                </div>
            </div>
        </div>
    )
}
